export class TestType {
  constructor() {
    return {
      name: null,
      prefix: null,
      type: null
    };
  }
}
